"use client";

import { c as _c } from "react/compiler-runtime";
import { Award, Star, Target, TrendingUp } from "lucide-react";
interface StatsGridProps {
  predictionsMade: number;
  winRate: number;
  totalPoints: number;
  badgesEarned: number;
  labels: Record<string, string>;
}
export default function StatsGrid(t0) {
  const $ = _c(25);
  const {
    predictionsMade,
    winRate,
    totalPoints,
    badgesEarned,
    labels
  } = t0;
  const t1 = labels.predictionsMade;
  let t2;
  if ($[0] !== predictionsMade) {
    t2 = predictionsMade.toLocaleString();
    $[0] = predictionsMade;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== labels.predictionsMade || $[3] !== t2) {
    t3 = {
      icon: Target,
      label: t1,
      value: t2,
      color: "text-primary"
    };
    $[2] = labels.predictionsMade;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${winRate}%`;
  let t5;
  if ($[5] !== labels.winRate || $[6] !== t4) {
    t5 = {
      icon: TrendingUp,
      label: labels.winRate,
      value: t4,
      color: "text-emerald-500"
    };
    $[5] = labels.winRate;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = labels.totalPoints;
  let t7;
  if ($[8] !== totalPoints) {
    t7 = totalPoints.toLocaleString();
    $[8] = totalPoints;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== labels.totalPoints || $[11] !== t7) {
    t8 = {
      icon: Star,
      label: t6,
      value: t7,
      color: "text-amber-500"
    };
    $[10] = labels.totalPoints;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = labels.badgesEarned;
  let t10;
  if ($[13] !== badgesEarned) {
    t10 = badgesEarned.toLocaleString();
    $[13] = badgesEarned;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== labels.badgesEarned || $[16] !== t10) {
    t11 = {
      icon: Award,
      label: t9,
      value: t10,
      color: "text-violet-500"
    };
    $[15] = labels.badgesEarned;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t3 || $[20] !== t5 || $[21] !== t8) {
    t12 = [t3, t5, t8, t11];
    $[18] = t11;
    $[19] = t3;
    $[20] = t5;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const stats = t12;
  let t13;
  if ($[23] !== stats) {
    t13 = <div className="grid grid-cols-2 gap-4 md:grid-cols-4">{stats.map(_temp)}</div>;
    $[23] = stats;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}
function _temp(stat) {
  return <div key={stat.label} className="rounded-lg border border-border bg-card p-4"><div className="mb-2 flex items-center gap-2"><stat.icon className={`h-5 w-5 ${stat.color}`} /><span className="text-sm text-muted-foreground">{stat.label}</span></div><p className="text-2xl font-bold text-foreground">{stat.value}</p></div>;
}